module.exports = __webpack_public_path__ + "img/1.1cd21cc5.jpeg";